import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

export default function SpiceProductEdit() {
    const history = useNavigate();

  const [file13, setFile13] = useState(null);
  const [inputVal13, setinputVal13] = useState({
    SpiceProductimg:"",
    SpiceProductDescription:"",
    fname13: "",
    date: "",
  });

  const setData = (e) => {
    const { name, value } = e.target;
    setinputVal13((Data) => {
      return {
        ...Data,
        [name]: value,
      };
    });
  };
  const { id } = useParams("");
  console.log(id);
  const getData = async () => {
    const res12 = await fetch(`https://pratik-agro-backend.vercel.app/getSpiceProductimg/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data3 = await res12.json();

    if (res12.status === 422 || !data3) {
      console.log("error");
    } else {
      console.log(data3);
      setinputVal13({
         SpiceProductimg: data3.SpiceProductimg,
         SpiceProductDescription: data3.SpiceProductDescription,
      fname13: data3.fname13,
      date: data3.date,
    });
  }
  };
  useEffect(() => {
    getData();
  },[]);

  const updateData13 = async (e) => {
    e.preventDefault();

    console.log(inputVal13);

    var formData13 = new FormData();
    if (file13 != null) {
      formData13.append("image13", file13);
    }
    formData13.append("fname13", inputVal13.fname13);
    formData13.append("date", inputVal13.date);
    formData13.append("SpiceProductDescription", inputVal13.SpiceProductDescription);

    for (var pair of formData13.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    axios
      .post(`https://pratik-agro-backend.vercel.app/updateSpiceProductimg/${id}`, formData13, config)
      .then((res) => {
        if (res.status === 201) {
          console.log(res.data);
          history("/SpiceProduct");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
      });
  };
  return (
    <div className='content'>
         <div className="container mt-5 ">
          <Link className="btn btn-dark" to="/SpiceProduct">
          <i class="bi bi-arrow-left-circle-fill"></i>
          </Link>
        </div>

        <form className="mx-auto mt-5 shadow p-5">
          <div className="container ">
            <h6>Fill This Form:-</h6>
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label"> Product Image:</label>
            <input
              type="file"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="image13"
              onChange={(e) => setFile13(e.target.files[0])}
              value={inputVal13.image13}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Product Name: :</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              name="fname13"
              onChange={setData}
              value={inputVal13.fname13}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Description :</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              name="SpiceProductDescription"
              onChange={setData}
              value={inputVal13.SpiceProductDescription}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Date:</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="date"
              onChange={setData}
              value={inputVal13.date}
            />
          </div>
          <div>
            <Link className="btn btn-success  mt-3" onClick={updateData13}>
              update Detail
            </Link>
          </div>
        </form>
    </div>
  )
}